enum AccessRightLevel {
	None = 0,
	Info = 1,
	Edit = 3,
	Full = 7,
	Deny = 16
}

export default AccessRightLevel;
